import type { Districts } from '../types'

export default [
  'Aust-Agder',
  'Vest-Agder',
  'Akershus',
  'Buskerud',
  'Finnmark',
  'Hedmark',
  'Hordaland',
  'Møre og Romsdal',
  'Nordland',
  'Oppland',
  'Oslo',
  'Rogaland',
  'Sogn og Fjordane',
  'Telemark',
  'Troms',
  'Nord-Trøndelag',
  'Sør-Trøndelag',
  'Vestfold',
  'Østfold',
] as Districts
